import dynamic from 'next/dynamic';

// AWS's `BrowserLiveView` pulls in the full DCV JS SDK + `@cloudscape-design`
// through `dcv-ui` at module-eval time (~3 MB minified). Load it only when a
// preview panel actually mounts so users who never open a browser session
// don't pay the download. `ssr: false` is required — the SDK reaches for
// `window.navigator`, `document`, and Web Workers at import time.
export const BrowserLiveView = dynamic(
  () => import('bedrock-agentcore/browser/live-view').then((m) => ({ default: m.BrowserLiveView })),
  { ssr: false },
);
